import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export interface IPageComponentHtmlData {
    text?: string;
}

@Component({
    selector: 'page-component-html',
    template: `<div class="text" *iCms="'text' of component; content: 'html'"></div>`,
    standalone: true,
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentHtmlComponent>({
    id: 'html',
    name: 'Free HTML',
    tags: ['text', 'html'],
    isAdvanced: true,
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy with HTML tags allowed',
            default: 'Lorem ipsum dolor',
            required: true
        }
    ]
})
export class PageComponentHtmlComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentHtmlData;
}
